// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 97.35 78.09\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#78a200\" d=\"M.01 68.43L19.36 0l34.2 9.67L34.23 78.1z\"/><path fill=\"#00363d\" d=\"M97.57 68.38l-34.13 9.6-9.6-34.12 34.13-9.6z\"/></g></svg>";
// Exports
module.exports = code;